import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import _ from 'lodash';
import { appDownloadPromptEnabled } from 'helpers/ConfigHelper';
import { appIconUrl, getAppUrl } from '../../HeaderHelpers';
import style from './AppDownloadButton.module.scss';

const AppDownloadButton = ({
  campaignOverrides,
  isLivePage,
  isWatchPage,
  mobileCategories = false,
}) => {
  if (!appDownloadPromptEnabled() || !mobileCategories) return null;
  const { app_mobileMenuPromoCTA: buttonText } = window.Language;
  const { appDownload } = window.ExternalConfig;
  const imageAltName = _.get(appDownload, 'title', '');

  const iconUrl = appIconUrl({ campaignOverrides });
  const storeLink = getAppUrl({ isLive: isLivePage, isWatch: isWatchPage, campaignOverrides });

  return (
    <Link
      key="appDownloadButton"
      href={storeLink}
      className={style.appDownloadGroup}
      onlyActiveOnIndex
    >
      <div className={style.appDownloadButton}>
        <button type="button">
          <img className={style.appDownloadButtonImage} src={iconUrl} alt={imageAltName} />
          {buttonText}
        </button>
      </div>
    </Link>
  );
};

export default AppDownloadButton;

/* eslint react/require-default-props: 0 */
AppDownloadButton.propTypes = {
  campaignOverrides: PropTypes.shape({}).isRequired,
  isLivePage: PropTypes.bool.isRequired,
  isWatchPage: PropTypes.bool.isRequired,
  mobileCategories: PropTypes.bool,
};
